import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useDataConnectorAdoption } from "../../hooks/useDataConnectorAdoption";
import AdoptionPieCard from "../AdoptionPieCard/AdoptionPieCard";
import ConnectionsTable from "../ConnectionsTable/ConnectionsTable";
import WeeklyConnectionsCard from "../WeeklyConnectionsCard/WeeklyConnectionsCard";

const DataConnectorAdoptionDashboard: React.FC = () => {
  const { summary, loading } = useDataConnectorAdoption();

  return (
    <MainPageWrapper title="Data Connector Adoption">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
        <AdoptionPieCard loading={loading} summary={summary} />
        <WeeklyConnectionsCard loading={loading} summary={summary} />
      </div>

      <Tabs defaultValue="connections">
        <TabsList>
          <TabsTrigger value="connections">Connections</TabsTrigger>
          <TabsTrigger value="stale">Stale Data</TabsTrigger>
        </TabsList>
        <TabsContent className="mt-4" value="connections">
          <ConnectionsTable />
        </TabsContent>
        <TabsContent className="mt-4" value="stale">
          <ConnectionsTable
            noDataMessage="No stale connections found"
            staleOnly
          />
        </TabsContent>
      </Tabs>
    </MainPageWrapper>
  );
};

export default DataConnectorAdoptionDashboard;
